import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import Home from '../pages/Home/Home';
import PartnerStoriesPage from '../pages/PartnerStories/PartnerStoriesPage';
import OurPlatform from '../pages/OurPlatform/OurPlatform';
import Insights from '../pages/Insights/Insights';
import Contact from '../pages/Contact/Contact';
import NotFound from '../pages/NotFound';
import Layout from '../components/layout/Layout';
import OnProperty from '../pages/Solutions/OnProperty/OnProperty';
import MarriottDigital from '../pages/Solutions/MarriottDigital/MarriottDigital';
import OffsiteDigital from '../pages/Solutions/OffsiteDigital/OffsiteDigital';
import GreaterChinaLaunch from '../pages/PressReleases/GreaterChinaLaunch';

function AppRouter() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path='/' element={<Home />} />
        <Route path='/partner-stories' element={<PartnerStoriesPage />} />
        <Route path='/our-platform' element={<OurPlatform />} />
        {/* <Route path='/insights' element={<Insights />} /> */}
        <Route path='/contact' element={<Contact />} />
        <Route path='/solutions/on-property' element={<OnProperty />} />
        <Route path='/solutions/marriott-digital' element={<MarriottDigital />} />
        <Route path='/solutions/offsite-digital' element={<OffsiteDigital />} />

        <Route path='/press-releases/greater-china-launch' element={<GreaterChinaLaunch />} />

        {/* Wildcard to handle 404s */}
        <Route path='*' element={<NotFound />} />
      </Route>
      {/* <Route path='/legacy' element={<MLandingPage />} /> */}
    </Routes>
  );
}

export { AppRouter };
